import React from "react";
import Icons from "../../common/components/Icons";
import Paragraph from "../../common/ui/Paragraph";
const Card = ({ obj }) => {
  return (
    <div className="p-4 rounded-2xl border border-solid border-[#3F8A31] group shadow-[0px_4px_17.7px_0px_#0000001A] hover:shadow-transparent">
      <div className="relative aspect-[647/340] overflow-clip rounded-xl">
        <img
          src={obj.image}
          className="absolute top-0 left-0 h-full w-full object-cover group-hover:scale-105"
          onError={(e) => (e.currentTarget.style.display = "none")}
          alt="gallery content"
        />
      </div>
      <Paragraph variant="success" className="pt-3 md:pt-4 pb-1 md:pb-2">
        by {obj.admin} // {obj.date}
      </Paragraph>
      <h2 className="text-lg font-semibold text-custom-black leading-normal line-clamp-1">
        {obj.title}
      </h2>
      <Paragraph className="mt-3 md:pt-4 mb-3 md:mb-5 line-clamp-2">
        {obj.description}
      </Paragraph>
      <button className="text-base md:text-lg font-normal text-custom-blue-v2 leading-normal inline-flex items-center  md:gap-x-4 gap-x-3 group/cta">
        Read More
        <Icons
          className="group-hover/cta:translate-x-1 max-md: w-6"
          icon="read-more-arrow"
        />
      </button>
    </div>
  );
};

export default Card;
